import React, {useState, useEffect} from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import apiUrl from '../../../Apiurl';
import axios from "axios";
import { createPortal } from 'react-dom';
import FunzioniStampaPOP from './FunzioniStampaPOP';

function CreaReport({ordini,classe,testo,tema,datiTendineOrdine,vista}) {

    const [popUpWindow, setPopUpWindow] = useState(false);
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");

    useEffect(() => {
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]);

      const setFinestra = function (e, finestra) {
        e.preventDefault();
        setPopUpWindow(finestra)
    }

    /* const impostaStato = async function() {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        let idOrdini;
        try {
            idOrdini  = ordini.map(ord => ord.id)
        } catch (err) {
            console.log("Errore nella creazione array ID ordini: " + err)
            throw err;
        }
        console.log(idOrdini);
        try {           
            const data = {
                idOrdini: idOrdini
            }

            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                  },
              }
              axios.post(apiUrl + "/logistica/pdf/ordiniByID", data, config)
                        .then(data => window.open(apiUrl + data.data))
        } catch (err) {
            console.log("Errore nell'invio degli ordini alle API': " + err)
            throw err;
        }
    } */

    function chiudi(e) {
        e.preventDefault();
        setPopUpWindow(false);
    }

    return (
        <div>
            <button className={classe} title="Stampa ordini" onClick={(e) => { setFinestra(e, "stampa") }}>{testo}</button>
            {popUpWindow === "stampa" && <div>
                {createPortal(
                    <div id="modal-root">
                        <div className='modal' onClick={chiudi}>
                        </div>
                    </div>,
                    document.body)}
                {createPortal(
                    <div id="modal-content">
                        <div className={"bg-white " + tema + " finestraPopUp"}>
                            <FunzioniStampaPOP
                                setPopUpWindow={setPopUpWindow}
                                tema={tema}
                                datiTendineOrdine={datiTendineOrdine}
                                ordiniSelezionati={ordini}
                                vista={vista}
                            />
                        </div>
                    </div>,
                    document.body
                )}
            </div>}
        </div>

    )
}


export default CreaReport;
